import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Workflows from './components/Workflows';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 text-white overflow-hidden">
      <Header />
      <main>
        <Hero />
        <Features />
        <Workflows />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}

export default App;